module.exports = {
	common: {
		hello: '哈囉!',
	},
	navigator: {
		choose: '入住玖樓',
		filter: '條件搜尋',
		map: '地圖搜尋',
		pauian: '玖樓璞園',
		personalized: '為我推薦',
		ninthfloor: '玖樓',
		about: '關於',
		media: '媒體',
		team: '團隊',
		contact: '聯繫',
		service: '服務',
		space: '空間管理',
		coliving: '共居生活',
		journal: '日誌',
		community: '社群',
		news: '消息',
		note: '筆記',
		guide: '指南',
		member: '會員',
		overview: '總覽',
		setting: '會員設定',
		favorites: '最愛收藏',
		propertyHistory: '預約記錄',
		reservationHistory: '入住紀錄',
		onlineCommunity: '線上社群',
		login: '登入',
		logout: '登出',
		register: '註冊',
		loginOrRegister: '登入/註冊',
	},
	banner: {
		search: '開始搜尋',
	},
	footer: {
		room: '入住玖樓',
		filter: '條件搜尋',
		map: '地圖搜尋',
		pauian: '玖樓璞園',
		personalized: '為我推薦',
		ninthfloor: '玖樓',
		about: '關於玖樓',
		team: '團隊夥伴',
		space: '空間管理',
		coliving: '共同生活',
		community: '線上社群',
		news: '最新消息',
		help: '協助',
		how: '如何申請',
		FAQ: '常見問題',
		contact: '聯繫我們',
		media: '媒體專區',
		moveIn: '入住條款',
		privacy: '隱私權政策',
		termsofService: '服務條款',
		sitemap: '網站地圖',
		description: '服務說明',
	},
	reservation: {
		MORNING: '上午',
		AFTERNOON: '下午',
		live: '現場看房',
		phone: '電話諮詢',
		online: '線上看房',
		checkin: '入住',
		checkout: '退房',
		interview_phone: '電話訪談',
		interview_online: '線上訪談',
		notValidText: '哎呀！還有沒填寫到的資料，趕快檢查並填寫完成唷！',
		notValidReserve: '抱歉，本時段已被搶先預約，請重新選擇',
		notReserveCheckinDate: '沒有適合的時段？請電話聯繫工作人員安排入住。（電話：+886 908959613）',
		notReserveCheckoutDate: '沒有適合的時段？請電話聯繫工作人員安排退房。（電話：+886 908959613）',
		checkinTime: '入住時間',
		checkoutTime: '退房時間',
		ViewTime: '看房時間',
		checkinDescription: '入住說明',
		checkoutDescription: '退房說明',
		ViewMethod: '看房方式',
		checkinResult:
			'很開心您加入玖樓，入住日當天將由社群經理協助辦理入住，約需花費一個小時，要幫我們將時間保留下來唷！社群經理將帶您認識共同生活空間、室友、生活需注意的小細節，讓您可以更快融入大家唷！',
		checkoutResult:
			'提醒您: 退房時，請將承租空間恢復至入住時原貌，並將私人物品及垃圾帶走。退房手續將按照入住條款內之細則辦理。道別後也別忘記要記得回來看看大家哦：)',
		referenceNumber: '預約編號',
		address: '地址',
		time: '時間',
		phoneNumber: '聯絡電話',
		name: '姓名',
		cancelAnAppointment: '取消預約',
		changeAnAppointment: '變更預約',
		fillOutTheSurvey: '填寫回饋',
		successful: '預約成功',
		successDescription:
			'太好了！您的預約已成功，相關資訊已寄至您的email信箱，也可隨時至會員中心查看。如有任何異動，我們將以email進行通知。若於預約時間24小時內之異動，我們將第一時間與您電話聯繫。如欲取消或變更預約。',
		viewReservation: '觀看預約',
		backToRoom: '返回房源',
		ninefloor: '玖樓',
		calendar: '月曆',
		addToCalendar: '加到月曆',
		gtm: '以下預約時段為台灣 GMT+8 時區時間',
		next: '下一步',
		edit: '確認預約',
		phoneDescription: '目前僅支援台灣區號碼，如人在國外，請選擇線上看房噢。',
		hangoutDescription:
			'線上看房使用 google hangout 進行，預約登記完畢後，將發送會議連結至聯絡信箱。',
		hangout: '您的 google hangout 帳號',
		hangoutAccount: '帳號',
		chooseTypeValid: '請先選擇看房方式才能完成預約喔！',
		checkPhoneAndHangoutAlert: '請填寫正確的聯絡電話/google hangout 帳號才能完成預約喔！',
		cancelSuccess:
			'取消預約成功，任何問題歡迎聯繫 <a class="underline" href="mailto:service@9floorspace.com">service@9floorspace.com</a> 或 撥打 +886 908959613',
		updateSuccess:
			'更新預約成功，任何問題歡迎聯繫 <a class="underline" href="mailto:service@9floorspace.com">service@9floorspace.com</a> 或 撥打 +886908959613',
		recordIsEmpty: '目前尚無任何預約紀錄',
	},
	settings: {
		welcomeText: '歡迎加入！完成會員申請剩下最後一步，完成申請資料，讓我們再更認識您吧！',
		deniedText:
			'嗨！很抱歉您的資料未通過審核，可能是資料填寫不夠完全或是資料有誤，歡迎修正後再次送出申請或是與我們聯繫。',
		notValidText: '哎呀！還有沒填寫到的資料，趕快檢查並填寫完成唷！',
		notValidCertificate: '哎呀！你填寫的資料格式有誤，請重新檢查',
		nameTooltip: '注意：請填寫與證件相符之中文或英文全名，未來入住時將進行第二次審核',
		sexTooltip: '因宿舍房型有生理性別限制，而需填此選項',
		passportTooltip: `擁有中華民國身分證者請提供身分證字號。
注意：請確實填寫證件號碼，未來入住時將進行第二次審核。`,
		skillsTooltip: '例如：廚藝、木工、素描、語言、人體計算機',
		presonalTooltip: '請用300字以內簡單說明自己的背景，以及談談對入住玖樓的生活想像或期待。',
		privacyTooltip:
			'住進我們的社群，連結更多有趣的人事物，選擇公開，我們將會於線上社群對其他入住室友開放您的社群資料。',
		nicknameTooltip: '希望村民們怎麼稱呼您呢？',
		avatarTooltip: '請上傳可辨認的個人照片以便審核。',
		introductionTooltip: '讓村民們可以更快地認識您喲！',
		socialTooltip: '*由於審核需要，首次申請請至少留一項，申請通過後可再變更！',
		addAvatar: '自訂頭像',
		reviewUploadPhoto: '請上傳可辨認的個人照片以便審核。',
		basicInformation: '個人資料',
		nameAlert: '注意：請填寫與證件相符之中文或英文全名，未來入住時將進行第二次審核',
		selectFile: '選擇檔案',
		passportType: '證件類型',
		passportNumber: '證件號碼',
		name: '姓名',
		fullName: '姓名全名 ',
		sex: '生理性別',
		sexAlert: '因合住房型有性別限制，故需填此選項',
		dateOfBirth: '生日',
		selectBirthday: '請選擇生日',
		nationality: '國家',
		selectNationality: '請選擇國家',
		passport: '證件',
		workingArrangements: '工作型態',
		jobTypes: '請選擇工作型態',
		skills: '專長',
		skillTypes: '請選擇專長',
		phoneNumber: '聯絡電話',
		personalIntroduction: '自我介紹＆對社群的想像',
		words300: '請用300字以內簡單說明自己的背景，以及談談對入住玖樓的生活想像或期待。',
		communityProfile: '社群資料',
		privacySetting: '是否公開',
		privacyDetail:
			'住進我們的社群，連結更多有趣的人事物，選擇公開，我們將會於線上社群對其他入住室友開放你的社群資料。',
		nameForDisplay: '顯示名稱',
		nickname: '希望村民們怎麼稱呼你呢？',
		company: '公司名稱',
		occupation: '職業',
		selectOccupation: '請選擇職業',
		shortIntroduction: '社群短自介',
		words150: '請用 150 字內文字介紹自己，讓村民們可以更快地認識你喲！',
		personalInterests: '興趣標籤',
		interests: '請選擇興趣',
		website: '新增其他社群帳號/個人網站',
		music: '喜歡的歌曲',
		spotify: '從Spotify中選擇',
		accountLink: '社群帳號連結',
		alertAccountLink: '由於審核需要，首次申請請至少留一項，申請通過後可再變更！',
		instagram: 'Instagram',
		instagramLink: 'Instagram 綁定',
		save: '儲存',
		submit: '送出申請',
		FEMALE: '女',
		MALE: '男',
		OTHER: '',
	},
	bookingBar: {
		available: '招募中',
		notAvailable: '未開放',
		canBooking: '可即刻入住',
		waitRelease: '即將釋出',
		releaseTime: '{{YYYY}}年{{MM}}月{{DD}}日',
		month: '月',
		view: '預約看房',
		book: '預訂入住',
		noBook: '目前不開放',
		reserved: '已預約',
		continue: '預訂續住',
		checkout: '預約退房時間',
		reservedMessage: '您已經預約了此房間的{{eventType}}，看房日期為 {{time}}',
		verifying: '我們尚未收到您的{{link}}，因此還無法預約看房唷！',
		verifyingData: '申請資料',
		verifyingPending:
			'資格審核中: 會員資格審核時間約為2-3個工作天（未含六日、國定假日），如未逾期仍未收到結果通知請連繫我們。',
		verifyingDenied:
			'由於你此次申請會員資料填寫不夠充分，沒有通過審核，因此無法預約看房。建議重新填寫會員申請，並多多介紹你自己',
		excessUserReserve: '您已超過本月可預約次數',
		excessRoomReserve: '目前本房預約看房人數過多，建議預約其他房源，或先加入收藏。',
		reject: '由於您已違反玖樓社群規章，我們將暫停您所有玖樓相關服務的使用權利。',
		notCertificated: '預訂入住為認證會員的功能。詳情請參考{{link}}',
		viewIntro:
			'很開心能邀請您來探索玖樓，在預約心儀房源之前請務必詳讀以下規則：\n\n1. 變更/取消\n   a)如需 變更/取消 預約需在24小時前至會員頁進行變更\n   b)如臨時不能到或延後抵達時間，請主動致電給我們的工作人員\n   c)無故未到者 ，兩個月內將無法預約及預訂玖樓居住空間\n2. 當次預約，如因其他會員預定此房間，我們將第一時間以email進行變更通知。如距離原訂時間24 小時內，則由電話即時通知\n3. 每位會員每月有 3 次無收費的看房機會。\n\n有乖乖看完相關規定嗎？快來找我們玩吧！',
		bookIntro: `入住玖樓的流程可能有些與您先前的租房經驗不太相同：

1. 玖樓使用藍新金流NewebPay為支付系統， 支援 Visa, MasterCard, JCB 之信用卡、簽帳金融卡。
2. 收到訂單後，玖樓仍會於24小時內進行最後審核，如申請者遞交的身份資料與會員資料不符，或因系統原因導致重複預定，玖樓將保留取消訂單之權利。
3. 訂單確認完成後，於入住前如需變更房源、取消預定，本筆預訂之行政手續費將不會退還。

提醒：
1. 預訂入住僅限定會員本人入住，於流程中我們將進行身份驗證，切勿使用他人帳號進行預訂
2. 首期款項含：押金（兩個月租金）、行政手續費（1500元）、退房清潔費（1500元）
3. 如為第二人入住，請確認房源有開放此服務，同時確實於訂單中進行加購
以上行為如有違反，經查證後，將直接取消會員資格，詳細參見我們的`,
		term: '服務說明',
		serviceGuide: '服務說明',
		bookIntroEnd: '\n讀完了，離完成預定剩三步驟唷！',
		checkoutIntro: '退房時，將由社群經理為您辦理退房手續，並與您進行當面點交。（退房手續詳見',
		checkoutTerm: '服務條款',
		checkoutIntroEnd:
			'） 提醒您：請將承租房間恢復至入住時原貌，並將私人物品及垃圾帶走，否則將產生相關處理費用。 道別後也別忘記回來看看大家哦：）',
		start: '開始預約',
		next: '下一步',
		renew: '續訂',
		renewIntro: `謝謝你/妳對玖樓的社群及服務的支持，也期待在接下來更多的日子我們能持續激盪出更多精彩的生活及故事。
續訂注意事項如下：

1.本訂單最晚可續約日期為 {{renewDate}}
2.續訂將不會重複收取行政手續費、退房清潔費及押金，如原本為六個月以上訂單，首次續訂不論租期，皆可享有長租價格。
3.如扣款信用卡有變更，可於訂單完成後，至訂單詳情頁進行變更。`,
		appointment: '預約入住時間',
		appointmentIntro:
			'很開心您加入玖樓，入住日當天將由社群經理協助辦理入住，約需花費一個小時，要幫我們將時間保留下來唷！ 社群經理將帶您認識共同生活空間、室友、生活需注意的小細節，讓您可以更快融入大家唷！',
	},
	booking: {
		notValidText: '哎呀！還有沒填寫到的資料，趕快檢查並填寫完成唷！',
		notValidCertificate: '哎呀！你填寫的資料格式有誤，請重新檢查',
		notAcceptText: '哎呀！請記得勾選同意入住條款',
		notAcceptInsuranceText: '哎呀！請記得勾選保險政策',
		notValidFormat: '哎呀！有資料填寫錯誤，請趕快檢查並填寫完成唷！',
		empty: '目前尚無任何入住紀錄',
		notValidCreditNumber: '信用卡資訊錯誤',
		notValidCreditDate: '到期日資訊錯誤',
		notValidCreditCVC: '安全碼資訊錯誤',
		expiredCreditCard: '信用卡授權失敗',
	},
	bookingOrder: {
		invoiceInformation: '訂單資訊',
		bookingTimezone: '以下預約時段為台灣 GMT+8 時區時間',
		orderStartDate: '起租日期',
		leaseEnd: '租期結束月份',
		leaseEndPlaceholder: '請選擇租期結束月份',
		longTermRentalPrice: '長租價格：NTD {{rent}}/月',
		middleTermRentalPrice: '短租3-5月：NTD {{rent}}/月',
		shortTermRentalPrice: '短租1-2月：NTD {{rent}}/月',
		optionalItems: '選配方案',
		itemizedInvoice: '訂單項目',
		orderDate: '訂單成立日期：',
		roomName: '房間：',
		address: '居住空間地址：',
		orderStartFrom: '訂單起始日：',
		orderStartTo: '訂單終止日：',
		next: '下一步',
	},
	bookingRent: {
		initialPayment: '首期款項',
		monthlyPayment: '每月扣繳',
		totalMonth: '共 {{count}} 個月',
		totalMonth_plural: '共 {{count}} 個月',
		total: '小計',
		deposit: '押金',
		monthlyPrice: '{{price}} NTD/月',
		depositDescription: '押金總額為兩期月租金。',
		administrativeFee: '行政手續費',
		paymentDetail: '付款明細',
		administrativeFeeDescription: `1.入住會員預訂每一房間之第一筆訂單成立時，將酌收新台幣1,500元整之訂單處理之行政手續費。
2.入住會員若按原約續訂相同房間，且兩筆訂單之承租時間無中斷，則續訂時，入住會員無須支付續訂訂單之行政手續費。
3.訂單成立至訂單終止期間內之訂單異動，將酌收新台幣1,500元整之訂單處理之行政手續費。`,
		cleaningFee: '退房清潔費',
		cleaningFeeDescription: `1.為確保每位入住會員都能有最好的環境品質，我們將統一收取退房清潔費，由專人進行清潔打掃。唯有嚴重污損與破壞情節者，我們將於點交時酌收清潔加時費用。
2.入住會員預訂每一房間之第一筆訂單成立時，將酌收新台幣1,500元整之退房清潔費。入住會員若按原約續訂相同房間，且兩筆訂單之承租時間無中斷，則續訂時入住會員無須支付退房清潔費。`,
		petCleaningFee: '寵物退房清潔費',
		petCleaningFeeDescription:
			'「寵物入住」將產生一筆新台幣1,000元整之「寵物退房清潔費」，此費用於訂單成立時酌收。入住會員若按原約續訂相同房間，且兩筆訂單之承租時間無中斷，則續訂時入住會員無須支付「寵物退房清潔費」。',
		monthlyRent: '月租金',
		monthlyRentDescription: '月租金為每月固定日期定期扣款，入住會員每期應繳納月租金。',
		serviceFee: '服務費',
		serviceFeeDescription: '服務費為入住會員共同分擔之公共空間清潔管理費用及垃圾收取服務費用。',
		energyPrice: '能源費',
		energyPriceDescription:
			'能源費為入住會員共同分擔之居住空間使用費用，包含：水費、電費、天然氣費以及網路費等費用。',
		petDescription: `1.入住會員得於玖樓開放飼養寵物之居住空間飼養寵物。每位入住會員至多飼養1隻寵物，飼養寵物以貓與狗為限。（特殊情況，應經玖樓同意始得攜入）
2.飼養寵物之入住會員每月須額外支付新台幣1,500元整之寵物入住費用。（導盲犬不在此限，且無需額外酌收費用。）`,
		extraPersionDescription:
			'玖樓之居住空間僅限於與玖樓成立訂單之入住會員1人居住使用。若入住會員承租之居住空間使用者超過1人之情況每月超過10日，玖樓得提前解約，或請求該入住會員每月需額外支付新台幣2,000元整之第二人入住費用。第二人於居住空間之使用規範與違規處理原則，與入住會員之規範相同。',
	},
	roomFilter: {
		select: '請選擇',
		city: '城市',
		neighborhood: '區域',
		MRT: '捷運站',
		MRTLine: '捷運線',
		surroundingMRT: '顯示周遭捷運站結果',
		station: '{{station}}站',
		line: '{{line}}線',
		type: '房型',
		anticipatedMovein: '預訂入住日期',
		chooseMonth: '月份複選',
		monthlyRent: '價格/月',
		limit: '上限/下限',
		particularApartment: '顯示特定居住空間',
		chooseApartment: '選居住空間',
		advancedSearch: '進階搜尋',
		size: '房間坪數',
		twoResidents: '第二人入住',
		all: '全部',
		allowed: '可以',
		notAllow: '不可以',
		pets: '養寵物',
		special: '居住空間特色',
		showUnavailable: '顯示目前無法預訂房間',
		clear: '清除',
	},
	roomType: {
		MEN_LIVING: '男生宿舍房',
		WOMEN_LIVING: '女生宿舍房',
		CO_LIVING: '混合宿舍房',
		ROOM: '雅房',
		STUDIO: '獨立套房',
	},
	roomStatus: {
		RENTED: '未開放',
		AVAILABLE: '招募中',
		FULL: '額滿',
	},
	room: {
		additional: '首期款項',
		monthAdditional: '每月小計',
		deposit: '押金',
		monthlyRent: '月租金',
		energyPrice: '能源費',
		energyPriceDescription:
			'能源費為入住會員共同分擔之居住空間使用費用，包含：水費、電費、天然氣費以及網路費等費用。',
		serviceFee: '服務費',
		serviceFeeDescription: '服務費為入住會員共同分擔之共享空間清潔管理費用及垃圾收取服務費。',
		shortRent: '短租方案',
		shortTerm: '短租',
		month: '月',
		info: '房間資訊',
		apartmentInfo: '居住空間資訊',
		type: '房型',
		size: '面積',
		ping: '坪',
		amenities: '房間設備',
		apartmentAmenities: '居住空間設備',
		neighborAmenities: '附近機能',
		transportation: '交通資訊',
		recommended: '房源推薦',
		recommendedApartment: '附近公寓',
		balcony: '陽台',
		kitchen: '廚房',
		sharedBathrooms: '公共衛浴',
		bedrooms: '房間',
		totalFloors: '總樓層',
		elevator: '是否有電梯',
		cleaningService: '清潔打掃',
		garbageDisposal: '垃圾處理',
		more: '更多',
		yes: '有',
		no: '無',
		roomSize: '坪',
		floor: '樓',
		room: '間',
		hasPet: '可以養寵物',
		roommate: '室友',
	},
	rooms: {
		UpToDate: '最新',
		HighestPrice: '最高價格',
		LowestPrice: '最低價格',
		location: '地點',
		price: '價格',
		advancedSearch: '進階搜尋',
		results: '筆結果',
		SortBy: '排序方式',
		More: '更多',
	},
	roomComponent: {
		photos: '所有照片',
	},
	userTabs: {
		overview: '總覽',
		settings: '設定',
		favorites: '收藏',
		viewingHistory: '預約紀錄',
		reservationHistory: '入住紀錄',
		request: '聯繫我們',
		onlineCommunity: '線上社群',
	},
	userOverview: {
		welcom: '歡迎加入！完成會員申請剩下最後一步，完成申請資料，讓我們再更認識您吧！',
		account: '我的帳號',
		editProfile: '修改個人資料',
		currentOrder: '目前預訂',
		checkinTime: '確認入住時間',
		details: '查看詳情',
		recent: '最近預約',
		incomplete: '哎呀！申請還差一步，趕緊到設定頁完成資料填寫，送出申請吧!',
		underPreview: '申請資料審核中',
		reject:
			'嗨！很抱歉您的資料未通過審核，可能是資料填寫不夠完全或是資料有誤，歡迎修正後再次送出申請 或是與我們聯繫。',
		needCheckin: '嗨！很快就是正式入住的日子，提醒您，記得於 {{startDate}} 前預約入住時間！',
		needCheckout:
			'時光飛逝，很快就來到要退房的日子了。提 醒您，記得於 {{endDate}} 前預約退房時間哦！',
		reserveMovein: '預約入住時間',
		reserveCheckout: '預約退房時間',
		member: '會員',
	},
	bookingRecordCard: {
		address: '地址',
		date: '訂單日期',
		moveinTime: '入住時間',
		moveinAppointment: '預約入住時間',
		checkoutAppointment: '預約退房時間',
		renew: '訂單續約',
		changeOrder: '訂單異動',
		download: '合約下載',
		changePayment: '變更付款方式',
		review: '待審核',
		cancel: '已取消',
	},
	bookingPayment: {
		DONE: '已收款',
		NEXT: '下一筆收款款項',
		WAIT: '待收應收款項',
		paymentHistory: '扣款紀錄',
		initialPayment: '首期款項',
		total: '總計：',
	},
	certificateType: {
		IDENTITY: '身分證',
		PASSPORT: '護照',
		userAddress: '戶籍地址或原國家居住地址',
		userAddressTooltip: '身分證件上之居住地址',
		certificateData: '證件資料',
		extraCertificateData: '第二入住人證件資料',
		certificateDescription: '請使用與基本資料裡姓名欄位相符的證件。',
		certificateField: '身分證字號 or 護照號碼。',
		emergencyName: '緊急聯絡人姓名',
		emergencyTelephone: '緊急聯絡人電話',
		emergencyRelationship: '緊急聯絡人關係',
		emergencyAddress: '緊急聯絡人地址',
		selectFile: '選擇檔案',
		passportType: '證件類型',
		passportNumber: '證件號碼',
		passportNumberTooltip: '身分證字號or護照號碼。',
		basicInformation: '個人資料',
		communityProfile: '社群資料',
		name: '姓名',
		fullName: '姓名全名 ',
		sex: '生理性別',
		dateOfBirth: '生日',
		nationality: '國籍',
		workingArrangements: '工作型態',
		skills: '專長',
		phoneNumber: '聯絡電話',
		personalIntroduction: '自我介紹＆',
		expections: '對社群的想像',
		next: '下一步',
		back: '上一步',
		term: '入住條款',
		agreeTerm: '我已詳閱，並同意此入住條款',
		insurance: '保險政策',
		insuranceContent:
			'我同意玖樓將為入住會員投保第三人責任險，將使用會員身份相關資料(本國籍身分證字號/護照號碼、生日、戶籍地址、聯絡號碼)進行加保。',
		agreeInsurance: '我已詳閱，並同意此保險政策',
	},
	modalLoginSignup: {
		forgetPasswordSendSuccess: '信件已寄出至 {{email}}，趕緊收信去吧！',
		verifySuccess: '信箱驗證成功！請完善個人資料，以完成申請流程。',
		welcomeBack: '「嗨！歡迎回來」',
		SignupLoginFail: 'oops! 帳號或密碼有錯哦，請重新輸入。',
		verifyEmailFail: '請輸入正確的 Email 格式',
		verifyPasswordFail: '密碼需要至少8個英數混合的字元喔！',
		verifyCheckPasswordFail: '你輸入的密碼不一致，請重新輸入',
		verifyAgree: '要同意服務條款才能註冊成功喔！',
		verifyFail: '您尚未驗證信箱喔！請點擊按鈕重新寄送認證信。',
		vipTokenFailed: '此驗證碼不存在，請直接註冊或聯繫工作人員（電話：+886 908959613）',
		agree: '同意',
		termsofService: '服務條款',
		register: '註冊新帳號',
		already: '已經註冊',
		loginNow: '立即登入',
		successful: '註冊成功',
		verification_email: '為確保後續服務流程順暢，請先前往驗證信箱唷！',
		back: '回首頁',
		resend: '重寄認證信',
		rememberMe: '記住我',
		login: '登入',
		forgot: '忘記密碼了嗎',
		reset: '點我重設',
		not_a_member: '還不是會員',
		application: '申請加入',
		resetPw: '忘記密碼了呀，沒關係，快來重設吧！',
		send: '送出',
		newPassword: '新密碼設定',
		placeholder1: '新密碼',
		placeholder2: '新密碼確認',
		becomeResident: '成為玖樓村民，一起探索城市、一起分享生活。 ',
		young: '年輕漂泊，',
		year: '最美好的那幾年。',
	},
	about: {
		bannerTitle: '關於玖樓',
		title1: '房子是租來的，但生活不是',
		title1Split1: '房子是租來的',
		title1Split2: '但生活不是',
		describe1:
			'成立於2015年，租不到像樣房子的台北，玖樓開始改造了10間老公寓，打造客廳、廚房成為類似咖啡館的半開放空間，簡約的設計吸引百餘位來臺北尋求夢想的學生、上班族、自由工作者、國際人士。新穎的物管模式，也吸引了許多屋主合作，掀起老屋欣立的新風潮。玖樓相信，人們不只在都市工作創業、上學實習，更應該「住」進一個社群，因著室友的共同生活互動，共享空間、知識、經驗與快樂。',
		title2Split1: '不只是硬體設備，更關乎人',
		title2Split2: '與人之間的關係',
		title2Split3: '不只是硬體設備，',
		title2Split4: '更關乎人與人之間的關係',
		describe2:
			'藉著空間設計、管理服務以及會員制的經營，玖樓致力於提升空間居住與物業管理品質，提供市場更好的居住選擇。讓室友們一起共食、看電影，工作、讀書會或小型聚會自然地發生在日常家裡，藉由共同居住、生活，在一般認為私密的空間裡，創造人與人的連結、營造出公共性的可能。',
		title3Split1: '重新建立社區，',
		title3Split2: '共同實踐理想生活的樣貌',
		describe3:
			'作為一個關注社會創新的品牌，玖樓近年透過許多社群活動串連橫跨不同領域的住客。同時我們也打造實體跨世代的共同生活空間如三峽青銀共居宅，持續回應我們為自己設定的挑戰；如何打造城市裡更友善、更有趣、更宜居的生活體驗。透過社群經營與串連，讓社區互相支持的概念跨越實體空間，與住民共同實踐理想生活的樣貌。',
		qouteblock: '加入我們，分享彼此的世界，如約翰藍儂曾《想像》的那樣。',
		moreButton: '更多物件',
	},
	bookingFinish: {
		congratulations: '恭喜您！',
		content: '完成入住預訂。我們將儘速進行審核。再次感謝您的預訂，期待我們在玖樓相見！',
		checkDetails: '查看預訂詳情',
		returnToRoom: '返回房間頁',
	},
	page404: {
		headerText: '噢不！這裡似乎不是您要找的頁面。',
		paragraph: '錯誤代碼：404',
		buttonText: '回首頁',
	},
	contact: {
		contact: '聯繫',
		support: '客服',
		message: '點此留下訊息，讓我們能提供更好的協助，',
		request: ' ',
		inquiries: '其他疑問與服務需求，請聯繫 {{link}}',
		contactUs: '聯繫我們',
		respond: '居住問題通報',
		property: '物業夥伴',
		propertyDescription: '物業委託管理服務，歡迎留下{{link}}，我們會儘速與您聯繫',
		work: '工作夥伴',
		workDescription: '加入玖樓團隊，請參考{{link}}',
		investment: '投資夥伴',
		investmentDescription: '如果有興趣與我們一起創造更棒的居住生活產業，請聯繫{{link}}',
		media: '媒體',
		mediaDescription: '親愛的媒體夥伴，如想更深入了解玖樓，請至{{link}}查看詳情',
		cooperation: '合作提案',
		cooperationDescription: '歡迎留下{{link}}，我們會儘速與您聯繫',
		consulting: '顧問諮詢',
		consultingDescription: '空間規劃諮詢，歡迎留下{{link}}，我們會儘速與您聯繫',
		space: '空間基本資料與需求',
		teamPage: '團隊',
		mediaPage: '媒體頁',
		proposal: '相關資料',
		become: '成為',
	},
	service: {
		serviceGuide: '服務說明',
		member: '1. 玖樓會員',
		suTitle1: '為什麼要成為會員？',
		description1:
			'一直以來，玖樓努力打造更多更好的共同生活空間，但我們也明白，並非所有人都適合共同生活的概念。我們希望為追求自由開放與尊重多元的社群努力，並為社群的品質做把關。因此有別於一般的租賃招租，我們以會員制進行申請審核。一但通過審核，就是我們社群的一員、在不同階段可以享有我們的不同服務、包含社群活動、社群空間使用、居住空間的即時預訂入住等。同時我們也希望，透過持續的創新，未來提供更多的數位線上服務，建立真正無疆界的共生社區。',
		blockquoteTitle1: '我們在尋找的社群會員',
		blockquoteList1: '1.認同{{link}}的理念與社群文化',
		blockquoteList2: '2.尊重多元的社群樣貌，開放的面對與自己不同的價值或文化',
		blockquoteList3: '3.樂於分享，願意與社群一同共創成長',
		blockquoteList4: '4.勇於接受挑戰、嘗試解決問題',
		blockquoteList5: '5.互動隨和但生活不隨便',
		formTitle: '等級與權限',
		rowTitle1: '村民等級',
		rowTitle2: '審核方式',
		rowTitle3: '優惠權限與服務項目',
		rowTitle4: '說明',
		columnTitle1: 'L1-一般會員',
		column1Row1: '於網站送出申請資料後，通過審核者將會於2-3天內收回覆通知。',
		column1Row21: '1.看房 3 次/30天',
		column1Row22: '2.社群電子報',
		column1Row23: '3.玖樓社群活動',
		column1Row3:
			'我們邀請認同自由與多元價值的你成為玖樓會員。通過後即享有看房服務、活動最新資訊，一起參與城市裡共生共創的玖樓社群。',
		columnTitle2: 'L2-認證會員',
		column2Row1:
			'透過預約看房、線上面談、活動參與等進一步了解彼此後，我們將視審核結果邀請成為認證會員。',
		column2Row21: '1.看房 3 次/30天',
		column2Row22: '2.社群電子報',
		column2Row23: '3.玖樓社群活動',
		column2Row24: '<b>4.即時預定房源</b>',
		column2Row3:
			'我們歡迎所有人，但共同生活不見得適合每個人。為了營造自由開放與彼此尊重的多元社群，並為共同生活的品質把關。我們會依照面談與實際接觸的情形進行審核評估後，發送邀請信給與我們理念契合的會員。一但升級為認證會員後便可隨時預定玖樓房源！',
		columnTitle3: 'L3- 入住會員',
		column3Row1: '預訂入住成功後即為入住會員。',
		column3Row21: '1.看房 3 次/30天',
		column3Row22: '2.社群電子報',
		column3Row23: '3.玖樓社群活動',
		column3Row24: '4.即時預定房源',
		column3Row25: '<b>5.合作店家隱藏優惠</b>',
		column3Row26: '<b>6.線上社群功能</b>',
		column3Row3:
			'入住玖樓，成為一起生活的夥伴吧！入住會員享有合作店家優惠、專人客服、空間服務、以及持續更新推出的相關線上社群功能。在玖樓，你的室友將不只局限於同個屋簷，而是整個共享社群。',
		reservationExpantation: '2. 線上預約流程說明',
		description21: '無論是看房、諮詢、訪談、入住、退房等項目皆使用玖樓線上預約系統進行。',
		description22:
			'預約看房為<b>一般會員</b>以上等級方可使用的功能，每月我們提供3次的看房機會，流程如下:',
		description23: 'Step1：找到喜歡的公寓，點選預約看房，開始預約',
		description24: 'Step2：選取預計看房的時間，送出預約申請',
		description25: 'Step3：預約成功且收到看房相關資訊',
		blockquoteTitle2: '以下幾點規則也希望會員能夠留意我們的變更/取消規則：',
		blockquoteList21: '1.變更/取消預約需在24小時前會員頁進行變更',
		blockquoteList22: '2.如臨時不能來了或延後抵達時間，請主動並提前致電給工作人員',
		blockquoteList23: '3.遲到未主動通知或無故未到 ，兩個月內將無法預約及預訂玖樓公寓',
		blockquoteList24:
			'4.當次預約，如因其他會員完成預定入住此房間，我們將第一時間以email進行變更通知。如距離原訂時間24 小時內，我們會以專人與你電話聯繫。',
		bookingExpantation: '3. 線上預訂流程說明',
		description31: '線上預訂流程為<b>認證會員</b>專屬之功能',
		blockquoteTitle3: '六步驟完成預訂！',
		blockquoteList31: 'Step1: 至釋出的房間頁面點選“預訂入住”,開始預訂',
		blockquoteList32: 'Step2: 仔細確認訂單資訊，並詳閱入住條款',
		blockquoteList33: 'Step3: 完成付款方式綁定',
		blockquoteList34:
			'Step4: 完成預訂手續後，玖樓將於一個工作天進行審核並確認會員預訂資料正確無缺失',
		blockquoteList35: 'Step5: 完成預訂手續，預約入住時間',
		blockquoteList36: 'Step6: 暖心社群經理帶你入住玖樓新居',
		description32:
			'曾預約看房、{{link}}、參與社群活動等與我們有進一步互動的一般會員，我們將主動邀請當中合適且感興趣入住玖樓者，升級為{{strong}}，申請方式請參照第一點會員等級說明。',
		description33:
			'預訂入住僅限定會員本人入住，於流程中我們將進行身份驗證，切勿使用他人帳號進行預訂，如有違反經舉發，我們將取消會員資格，詳細參見我們的{{link}}。',
		payRefundExpantation: '4. 金流扣繳與退款說明 ',
		description41:
			'玖樓使用藍新金流NewebPay為支付系統， 支援 Visa, MasterCard, JCB 之信用卡、簽帳金融卡。',
		blockquoteList41: '1.訂單設定完成後，將於每月自動扣款。如有需要，可隨時至會員頁查看扣款紀錄。',
		blockquoteList42: '2.每月扣款日為租約起始日期。',
		blockquoteList43: '3.除了首期款項以外，我們並不會預扣金額。',
		blockquoteList44: '4.如有需要，未來仍可於會員頁變更扣款帳戶。',
		blockquoteList45:
			'5.如使用非台幣銀行卡，相關匯率以及手續費將由入住會員自行吸收，實際詳情請自行與銀行確認。',
		onlineCommunityRule: '5. 線上社群準則',
		description51:
			'線上社群目前為入住會員限定的最新功能。前往會員設定頁完成興趣標籤、instagram串連、最愛的歌曲等設定，並選擇公開即可有機會讓更多的室友認識你。同時你也能在線上社群裡快速搜尋趣味相投的村民，與這個無疆界的社群一起共同生活！',
		description52:
			'作為一個社群交流的平台仍有幾點需要大家一起遵守，如有違反經舉發，我們將列入計點，詳細參見我們的{{link}}',
		blockquoteTitle5: '第一次被玖樓拒絕往來就上手',
		blockquoteList51: '1.嚴禁蓄意地針對和欺凌。',
		blockquoteList52: '2.擅自散播他人的個人資訊或聯繫資訊。',
		blockquoteList53: '3.八卦：共同生活不代表要討論他人的私生活。',
		blockquoteList54: '4.缺乏尊重：與居民，鄰居和社區保持良好的關係。',
		blockquoteList55: '5.歧視：禁止基於宗教、性別、種族或經濟條件的歧視。',
		blockquoteList56: '6.性騷擾。',
		coliving: '共同生活',
		property_viewings: '線上面談',
		certified_members: '認證會員',
		terms_of_stay: '入住條款',
	},
	printOrder: {
		reservation: '住宅轉租契約（以下稱本契約）於民國{{link}}經承租人攜回審閱3日（契約審閱期間至少三日）。',
		printButton: '列印',
		invoiceInformation: '訂單資訊',
		orderDate: '訂單成立日期',
		room: '私人空間',
		apartmentAddress: '居住空間地址',
		movieInDate: '契約起始日期',
		checkoutDate: '契約結束日期',
		termsOfService: '入住條款',
		description: '立契約書人包租業共宅一生股份有限公司，入住會員 {{link}} 茲為住宅租賃事宜，雙方同意本契約條款如下：',
		companyInformation: '包租業資訊',
		companyName: '名稱',
		companyNameValue: '共宅一生股份有限公司',
		companyResponsible: '代表人姓名',
		companyResponsibleValue: '潘信榮',
		company: '名稱',
		companyNo: '統一編號',
		RegistrationCertificateNumber: '登記證字號',
		RegistrationCertificateNumberValue: '(107) 北市租登字第0003號',
		companyAddress: '營業地址 ',
		companyAddressValue: '台北市萬華區和平西路三段64號',
		user: '承租人（即入住會員）資訊',
		userName: '姓名',
		userBirthday: '出生年月日',
		userType: '證件類別',
		userNumber: '證件號碼',
		userTelephone: '聯絡電話',
		userAddress: '戶籍地址',
		emergencyContact: '緊急聯絡人',
		emergencyName: '姓名',
		emergencyTelephone: '電話',
		emergencyAddress: '地址',
		emergencyRelationship: '關係',
		manager: '租賃住宅管理人員',
		name: '姓名',
		certificateNumber: '證書字號',
		residentAddress: '通訊地址',
		residentAddressValue: '台北市萬華區和平西路三段64號',
		phoneNumber: '聯絡電話',
		mailAddress: '電子郵件信箱',
	},
	termsOfService: {
		serviceTerms: '服務條款',
		paragraph1: '歡迎加入玖樓（共宅一生股份有限公司）',
		paragraph2:
			'所謂「玖樓」是以藉由將空間經營與媒合或空間企劃服務等資訊介紹給各位消費者，為中華民國住宅法認定之租屋服務事業，並營運玖樓網站）',
		paragraph3:
			'（包括但不限於以jp/tw為網域之網站。以下簡稱「本網站」，包含如無論任何理由新增網域或内容，或為其他變更時，新增或變更後之網站。）',
		paragraph4: '以及提供本網站上所提供之服務（包括但不限資料提供以及社群媒體。）',
		paragraph5: '或提供其他相關服務之專案統稱（以下簡稱「玖樓專案」。）。',
		paragraph6:
			'身為玖樓營運母體之玖樓團隊將依以下利用規約（簡稱「本規約」。）向客戶提供服務、資訊。以下所謂之「玖樓」依文脈應個別或概括地代表玖樓專案、本網站或組成玖樓團隊之個人或法人。',
		paragraph7:
			'如客戶利用玖樓時，將視為已同意本規約，請仔細閱讀本規約。此外，如客戶將使用玖樓現在或未來的服務，連結至玖樓合作廠商網站或購買其商品時，無論本網站是否內含該等資訊，應遵從該服務或業務所適用之指導方針及利用規約。該等本規約以外之指導方針及利用規約內容、以及玖樓之服務說明等，如異於本規約內容，以本規約規定為優先適用。',
		title1: '關於隱私權 ',
		paragraph8: '隱私權政策適用於客戶利用玖樓時。',
		paragraph9: '煩請詳讀並予以理解。',
		title2: '電子通訊',
		paragraph10: '如客戶利用玖樓、或寄電子郵件予玖樓時，即表示客戶與玖樓正採用電子通訊之方式。',
		paragraph11:
			'客戶應預先同意由玖樓以寄信至客戶所註冊之電子信箱或於本網站刊登通知之方法或其他透過本網站進行之方法予以聯絡，以作為進行服務之營運上之告知、廣告、或作為功能之一環。客戶應同意玖樓以電子方式向客戶為所有合意、通知、資訊揭露或其他聯絡，係符合法律上以書面聯絡之要求。',
		title3: '著作權',
		paragraph12:
			'透過玖樓提供之所有內容物（包括但不限於文字、平面視覺設計、LOGO、按鈕圖示、圖片、影像、音頻片段、以數位形式下載者、加以編輯之檔案）為玖樓或內容物提供人之財產，受中華民國、日本著作權法及著作權相關國際法所保護。經玖樓提供之所有內容物之編輯物為玖樓之獨占財產，受中華民國、日本著作權法及著作權相關國際法所保護。經玖樓所提供之資訊及圖片等，謝絕未經許可之轉載。',
		title4: '利用之許可及網站之連結 ',
		paragraph13:
			'作為遵守本規約之條件，玖樓或內容物提供人授予客戶限定性、非獨占性、非商業性以及個人利用玖樓之權利（不得轉讓及再授權）。該利用之許可不包括玖樓或該內容物之轉售以及商業目的之利用、產品表單、解說、價格等之收集與利用、玖樓或該內容物之二次使用、為他人進行帳戶資料之下載與複製、資料探勘、機器人等之資料收集、抽取工具之使用。',
		paragraph14:
			'本規約或其他規約未明示授權之權利，均由玖樓N或其授權人、供應者、出版人、權利持有人或其他內容物權利人所保留。玖樓或其任何部分，除非獲得玖樓書面之明示性承諾，不得為商業目的之重製、複印、拷貝、銷售、轉售、連結或為其他利用。LOGO及玖樓所有之其他有財產權價值之資訊（包括但不限於圖像、文字、頁面布局、形式）除非取得書面之明示性承諾，不得採用框架(Frame)或使用框架技術套用之。禁止不當利用玖樓，僅得依適用之法律予以利用。其使用違反本規約及其他利用條件時，玖樓得於其裁量下，未經預告取消或終止授權、拒絕提供服務或停止帳戶。',
		title5: '帳戶',
		paragraph15:
			'利用本網站時，維護客戶帳戶與密碼之機密性、限制連結至電腦之責任是在客戶身上。此外，對於使用本身帳戶與密碼進行一切事項之責任，應同意縱於第三人未經客戶本人同意為之時或不當使用時，亦視為客戶自身所為之行為，將負一切責任。此外，如客戶將帳戶及密碼資訊洩漏予第三人時、或有洩漏之虞時，應盡速聯絡玖樓。玖樓得於獨自裁量下，未經事前通知，停止或終止該帳戶及密碼於本網站之利用。無論客戶有無故意過失，關於起因於帳戶及密碼遭盜用、遺失、第三人之不當使用，所導致暫時性停止使用或終止本網站等所生之一切費用（包括但不限於原因調査費用、防止再次發生之對策費用、律師費用、客訴因應費用等。）、損失及損害，客戶不得向玖樓提出請求。',
		paragraph16:
			'玖樓於其裁量下，保留未經預告拒絕提供服務、停止帳戶、刪除與編輯內容物、變更及停止活動或宣傳等之權利。',
		title6: '註冊事項之變更',
		paragraph17:
			'如EMAIL信箱等連絡方式或其他註冊事項變更時，應依所定方法，及時通知該變更事項。因客戶未提供正確聯絡方式或其他註冊事項以致受有無法獲取玖樓服務等不利益，玖樓概不負責。',
		title7: '致未成年之客戶 ',
		paragraph18:
			'依客戶所在國或地域之法令被認定為未成年者，請取得親權人或其他法定代理人同意後再進行註冊。如判斷確定未取得同意等，玖樓得立即拒絕提供服務以及停止帳戶。',
		title8: '評價、留言、通訊、其他內容物',
		paragraph19:
			'利用玖樓之客戶得進行留言、貼圖或其他內容物之發文、傳送提案、想法、意見、問題或其他資訊。但該等內容包括違反法令、猥褻、脅迫、毀損名譽、侵害隱私權、侵害智慧財產權、毀謗中傷第三人、令人感到不悅、或軟體病毒、政治主張、商業目的之勸誘、連鎖信、大量發信或所謂「垃圾信」，以及違反刑法第360條者，則不在此限。不得使用虛偽之EMAIL信箱、冒充他人或組織、其他內容物之出處進行招致誤解之行為。玖樓保有將該等內容刪除或編輯之權利（並非義務），但並非定期確認發文內容。',
		paragraph20:
			'客戶進行內容物之發文或傳送素材時，除非本網站明示其他決定，應視為客戶授予玖樓使用、重製、變更、改作、公開、翻譯該等內容物、作成、散布第二次著作物、得以所有媒體型態向全世界表示其為非獨占性、無償、永續性、無法取消、包括完整再授權之權利。客戶於玖樓與被轉授權人希望時，視為客戶就該等內容物對其授權使用客戶發文名稱之權利。此外，客戶不得對玖樓或玖樓再授權之第三人行使著作人格權。客戶應聲明、保證保有或管理自身發文內容物相關所有權利、該內容物係屬正確、所提供內容物之使用並未違反此政策、未傷害任何他人或組織、就起因於其提供之內容物之所有請求向玖樓提出補償。玖樓不保證確實記錄或保存發文之資訊或素材。縱使該等資訊或素材之全部或部分消失、變樣或外流，無論其原因為何，玖樓概不負責。玖樓保有監視、編輯或刪除任何行為或內容物之權利，但並無義務。玖樓對於客戶或第三人發文之任何內容物亦不負責，未生義務。',
		title9: '侵害智慧財產權之相關聲請',
		paragraph21:
			'玖樓尊重他人智慧財產。經判斷客戶之著作物於本網站上，遭以如構成侵害著作權或智慧財產之方法複印或使用時，請依玖樓適當指定之智慧財產權侵害相關聲請程序，提出聲請。',
		title10: '商品及服務說明',
		paragraph22:
			'玖樓將致力於盡可能保持正確性。但玖樓不保證商品説明或本網站其他內容正確、完整、具信賴性、為最新內容、或係為無誤。',
		paragraph23: '請留意本項規定僅適用於玖樓所介紹之商品。',
		title11: '得利用玖樓之軟體條件',
		paragraph24: '利用玖樓時，推薦以下瀏覽器之最新版本。',
		paragraph25: 'Google Chrome',
		paragraph26: 'FireFox',
		paragraph27: 'Safari',
		title12: '由第三人提供',
		paragraph28:
			'玖樓不對身為第三人之企業或個人、第三人之行為、商品、內容物負任何責任，亦不產生義務。建議請仔細閱讀各公司之隱私權相關文件與利用規約。',
		title13: '免責事項',
		paragraph29:
			'除非另有書面規定，客戶得透過玖樓及本網站利用之所有資訊、內容物、素材、商品（包含軟體）及其他服務，玖樓以「現狀之原有狀態」及「得提供之限度」提供之。玖樓除非另有書面規定，就玖樓之營運或本網站或玖樓所登載資訊、內容物、素材、商品無論其為明示或黙示，不為任何種類之聲明與保證。並視為客戶已明示同意以自身責任利用玖樓。特別就本網站保存之資料消失，或伺服機運轉停止所發生之客訴、爭議、損害賠償請求等情況之一切損害、責任，視為已明示同意免除玖樓責任。',
		paragraph30:
			'玖樓並未就客戶透過玖樓及本網站得以利用之所有資訊（以下簡稱「提供之資訊」。）相關商品或服務之購買、出售、持有或利用、或該等申請（以下統稱「購買等行為」。）為任何推薦。',
		paragraph31:
			'關於提供之資訊內容可能隨時變化，故請客戶勿全面依據提供之資訊，而係依自身判斷進行購買商品或服務等行為。無論其是否經由本網站，玖樓就客戶所為之商談或契約並非當事人，亦不對商議業務予以對應，且概不負責。',
		paragraph32:
			'玖樓不介入以利用本網站為契機發生之所有客戶間之協商、交易。就客戶間之交易所發生各種作業、連絡、法律義務之履行及問題處理等，應由客戶間負責為之。就起因於利用本網站為契機所為交易之損害，及起因於揭露提供之資訊一事本身之損害，玖樓概不負責。',
		paragraph33:
			'玖樓就得透過本網站連結或取得之產品或服務，於適用之法律所認可之範圍內，無論其為明示或默示，不為一切保證（包括但不限於未違反特定目的，及就該目的具市場性或合適性者。）。玖樓不保證資訊、內容物、材料、商品（包含軟體）、包含於玖樓其他服務或由其提供之服務、伺服器、由玖樓寄送之EMAIL，未感染病毒或其他有害因子。',
		paragraph34:
			'玖樓對於使用玖樓所生之任何種類之損害，包含但不限於直接、間接、附隨、懲罰性、必然性之損害亦不負責。',
		title14: '準據法',
		paragraph35:
			'利用玖樓時，視為已同意無論法律牴觸原則為何，以中華民國國內法規範利用此規約，以及客戶與玖樓或支援玖樓之企業間可能發生之，與玖樓有關之所有類型爭議。',
		title15: '爭議',
		paragraph36:
			'關於連結至本網站以及利用規約相關之爭議，除法律認可之管轄法院外，附加指定台北地方法院為合意管轄法院。但關於身為企業經營者之客戶，指定台北地方法院為專屬之合意管轄法院。',
		title16: '網站之營運方針、變更、可分性',
		paragraph37:
			'詳閱登載於本網站關於價格等事宜之本網站營運方針。該等方針亦就客戶利用玖樓一事予以規範。玖樓保留得隨時變更本網站、營運方針、利用規約之權利。該規約之一部分為不當或無效、或因任何理由而無法施行時，該規約視為可分，不影響此部分以外規約之有效性及拘束力。',
		title17: '關於本網站之營運母體',
		paragraph38:
			'本網站由玖樓團隊進行管理營運。就本規約中規定玖樓得持有或行使之一切權限及權利暨免責事項，以及支援玖樓之企業或其從業人員得行使或為主張。',
		title18: '詢問信箱',
		paragraph39: 'EMAIL: support@9floor.co',
		title19: '個人資料保護方針',
		paragraph40:
			'各位客戶您好:<br />關於此文件，請於提供玖樓個人資料前閱讀一遍。於您同意後，將提供個人資料所伴生之各種服務。',
		subTitle1: '1. 個人資料之收集、處理及利用目的',
		listDescription1:
			'・本服務就所取得之客戶個人資料，將以下揭目的（以下簡稱「利用目的」）利用之。',
		listTitle1_1: '(1)  本服務會員身份之利用',
		listItem1_1:
			'・作為註冊本服務會員利用服務時之登入時及登入後之身份認證、各種畫面中之會員資料自動顯示。',
		listTitle1_2: '(2)  本服務所提供交易之完成',
		listItem1_2:
			'客戶參加抽獎、線上報名等活動、回應客戶所詢問題、由本服務向客戶提出詢問、相關售後服務、其他完成交易所需業務。',
		listTitle1_3: '(3)  本服務之廣告宣傳或行銷等',
		listItem1_3_1: '・提供客戶各種電子報等資訊。',
		listItem1_3_2: '・以電子郵件、郵寄信件、電話等提供服務相關資料。',
		listItem1_3_3:
			'・對於客戶瀏覽之內容物或廣告依客戶之性別、年齡、居住地、興趣/嗜好等個人屬性或購物紀錄及本服務網站之瀏覽紀錄設定個人化資料。',
		listItem1_3_4: '・伴隨分析客戶於本服務之利用内容，開發新服務或改善現有服務。',
		listItem1_3_5: '・進行意見調查、活動、評價等與服務相關之客戶聯絡。',
		listTitle1_4: '(4)  回應客戶所詢問題',
		listItem1_4: '・回應客戶於本服務以電子郵件、郵寄信件等所為之詢問。',
		listTitle1_5: '(5)  其他伴隨本服務之利用',
		listItem1_5: '・伴隨上述(1)至(4)，就本服務之提供判斷有必要而利用之情況。',
		listTitle1_6: '(6)  提供予服務提供人',
		listItem1_6: '・依「3.個人資料等之提供/委託」提供個人資料予服務提供人。',
		listTitle1_7: '(7)  其他',
		listItem1_7:
			'・於個別服務亦可能以未規定於上揭內容之目的利用個人資料。於此情形時，將於個別服務網站中登載該內容。',
		subTitle2: '2. 個人資料之取得方法、利用期間與地區',
		listDescription2:
			'服務之提供方面，主要是取得如下之客戶相關資料。將取得之項目為非必要項目，而無法取得該項目時，可能無法提供本服務、回應客戶所詢問題等事宜，敬請見諒。',
		listDescription2_1:
			'再者，以下為例示，此外，依資料具體內容亦可能有未符合個人資料之情形，得依利用目的之差異或需求，增刪已收集之個人情報類別與項目，敬請見諒。',
		listTitle2_1: '(1)  客戶提供之資訊',
		listItem2_1:
			'・姓名、性別、出生年月日、居住地、使用語言、宗教、電子信箱、手機信箱、現在身處位置相關資訊及入住村民會員調查表之回答資訊等客戶所提供之一切資料。',
		listTitle2_2: '(2)  與利用服務有關而取得之資訊',
		listItem2_2:
			'・客戶申請玖樓提供之社群活動、或其他交易時之得以辨識客戶之資訊，與係屬附帶狀態之交易紀錄相關資訊。',
		listTitle2_3: '(3) 以連結為契機，機械上所取得之資訊',
		listItem2_3_1:
			'・客戶電腦連結網路時使用之IP位置、手機之機體辨識相關資訊（包含連結地點之資訊）。',
		listItem2_3_2:
			'・除以連結本網站為契機取得之所使用瀏覽器種類/版本、作業系統、平台等外，客戶瀏覽之網頁 (URL)、瀏覽日期時間、標示或查閱商品等相關資訊。',
		listItem2_3_3:
			'・除上述外，使用小型文字檔案(cookie)或網頁信號(web beacon)之技術取得之連結資料等，於每次客戶利用本服務自動收集/保管之資料。',
		listTitle2_4:
			'(4) 個人資料利用期間:自客戶最新登入日起算之一年間。但帳號遭刪除時，客戶的個人資料也將一併被刪除。',
		listTitle2_5: '(5) 個人資料利用地區:台灣、日本',
		subTitle3: '3. 個人資料等之提供/委託',
		listDescription3:
			'本服務依中華民國之個人情報保護法處理個人資料，除法令規定之情況外，未經客戶許可，未有將該資料揭露、提供予第三人之情形。但亦有於達成利用目的所需之範圍內，提供客戶個人資料、或委託處理個人資料之情形。於此情形下，於第三人之契約規定將進行與本文件同樣之資料管理，適當確認第三人身份及由第三人所為之管理體制。',
		listTitle3_1: '(1) 提供/委託之目的同於「1. 個人資料利用目的」。',
		listTitle3_2: '(2) 提供之個人檔案與「2.個人資料之取得方法」相同。',
		listTitle3_3: '(3) 提供、委託人之範圍為業務上所需服務之提供人。',
		listTitle3_4: '(4) 提供之手段、方法為本服務管理系統、CD-ROM等電子媒體、紙面等類比媒體等。',
		listTitle3_5:
			'(5) 要求停止向提供人、委託人提供資料時，請採取「5. 個人資料利用目的之通知、揭露、訂正/新增/刪除或利用之停止/消去/停止提供予第三人」之程序。',
		subTitle4: '4. 個人資料之保護',
		listDescription3_2:
			'就客戶所提供之個人資料為適當管理，為防止個人資料之洩漏、滅失、或毀損，乃從技術及管理面採取適當且合理之保護處置。此外，本服務約定依係屬營運公司之共宅一生股份有限公司之個人資料保護方針設置保護管理之負責人，於該負責人指示下，限定正當之服務進行範圍，嚴格進行收集/利用/提供/管理/保護。',
		subTitle5:
			'5. 個人資料利用目的之通知、揭露、訂正、新增或刪除、或個人資料之利用停止、消去或停止提供予第三人',
		listItem3_1:
			'・客戶個人檔案利用目的之通知及客戶個人檔案之揭露、訂正、新增、刪除、消去或停止提供予第三人之相關請求得自「Contact Us」為之。再者，如忘記使用者ID、密碼時，請參照FAQ頁面。',
		listItem3_2:
			'・關於刪除或消去之程序，由客戶本身自「FAQ」頁面為之或由客戶透過「Contact Us」提出請求。Fun! Japan將以停止利用服務或停止向第三人提供個人資料對應之。',
		listItem3_3:
			'・玖樓有保管備份檔案，以備電腦故障或其他不可抗力或人為疏失導致之檔案消失之情形。該備份檔案性質上無法進行確認等程序。',
		listItem3_4:
			'・客戶個人檔案利用目的之通知及客戶個人檔案之揭露、訂正、新增、刪除、消去或停止提供予第三人之相關請求得自「Contact Us」為之。再者，如忘記使用者ID、密碼時，請參照FAQ頁面。',
		listItem3_5:
			'・客戶利用本服務時，將視為已就「5. 個人資料利用目的之通知、揭露、訂正、新增或刪除或個人資料之利用停止、消去或停止提供予第三人」予以同意辦理。',
		subTitle6: '6. 未成年客戶之個人資料',
		listDescription3_3:
			'本服務就所提供之未成年人資訊，經謀求與大人同様之保護。但就依個人資料之當事人所在國或區域法令，經認定為未成年人者，按必要可能須得到家長同意。',
		subTitle7: '7. 個人資料相關詢問窗口',
		listDescription3_4: ' 關於個人資料之處理，如有不明瞭的地方，請參照求助網頁。',
		subTitle8: '8. 本網站之安全',
		listDescription3_5: '・本服務為確保客戶個人檔案之正確性、最新性，亦有可能請客戶予以協助。',
		listDescription3_6:
			'・本服務為確保安全，以防止個人輸入特定個人資料等重要資料時，該等資料遭竊取、受阻或竄改為目的，乃使用SSL（Secure Sockets Layer）技術。',
		paragraph42: '以上',
	},
	team: {
		team: '團隊',
		room: '房子是租來的，',
		life: '但生活不是',
		subject:
			'我們相信，決定未來靠 <a class="underline" href="https://www.ideo.com/post/the-ten-faces-of-innovation" target="_blank" rel="noopener noreferrer">10種人</a>；並不見得是最有能力的人，而是每一種角色，都有自己的槓桿、自己的工具、自己的技能，和自己的觀點。透過跨領域的共創結合起來，我們就能發揮驚人的力量，打造更友善的都市共同生活社區。',
		title1: '從實體社群出發，<br />我們希望每個夥伴都是人類學家',
		career1: '1.人類學家',
		careerDescription1: '在共生日常裡進行田野調查',
		career2: '2.看護人',
		careerDescription2: '理解室友的生活需求，<br />提供每個人適切合宜的居住選擇',
		career3: '3.說故事的人',
		careerDescription3: '透過生動故事和大眾溝通',
		career4: '4.實驗家',
		careerDescription4: '把生活問題、構想製成原型',
		title2: '多元創新，<br />是我們骨子裡流的血',
		career5: '5.跨欄運動員',
		careerDescription5: '不斷克服障礙抵達終點',
		career6: '6.體驗建築師',
		careerDescription6: '優化室友的日常生活體驗',
		career7: '7.異花授粉者',
		careerDescription7: '探索其他產業和文化應用於共生之中',
		title3: '共享共創，<br />這是一場弱連結的策展',
		career8: '8.導演',
		careerDescription8: '激發社群的內容與創造力',
		career9: '9.共同合作人',
		careerDescription9: '把各式各樣有趣的室友、外部團體結合',
		career10: '10.舞台設計師',
		careerDescription10: '把居住空間環境轉化成激發社群活力的舞台',
		summary:
			'我們在一條偉大的航道上，航向一個令人期待的未來。每個夥伴或許踏上這艘船的理由不盡相同，但我們盡可能地，與大家一起將夢想化為真實。',
		LinkedIn: '我們的LinkedIn',
		Medium: '我們的Medium',
		qouteblock: '如果想關注玖樓的職缺招募訊息，請追蹤我們的Medium ❤️',
	},
	media: {
		bannerTitle: '媒體',
		sectionDescription:
			'為了推廣共同生活空間，我們很樂意與大家分享玖樓的經歷與理念，可在此下載我們的品牌書。如果想進一步深入了解玖樓，歡迎留下您的採訪需求，我們會儘速與您聯繫。同時，也可先參以下考玖樓過往的媒體報導。',
		listTitle1: '台湾のまちづくり',
		listTitle2: '台北 「玖樓」共居實驗　捍衛跨代居住權益',
		listTitle3: '溝通是彼此價值的折衝與理解，追求更美好的共同生活',
		listTitle4: '我的老室友',
		listTitle5: '【玖樓】改造臺北老公寓 生活在一座不疏離的城市',
		listTitle6: '用老公寓盛裝生活新概念：填補世代居住落差，共生公寓「玖樓」',
		listTitle7: '「房子是租來的，但生活不是」：「玖樓」打造共生公寓，讓青年住進有生命力的空間',
		listTitle8: '住進一個社群 Living in a community',
		listTitle9: '「重新建立對家的想像！」推動共生公寓的玖樓團隊',
		listTitle10: '共居時代正興起！！經濟又拉近人際',
		listTitle11: '獨居不離群',
		listTitle12: '高房價城市中的空間共享：玖樓共生公寓―租屋生活的另一種可能',
		listTitle13: '同居新定義－玖樓打造對家的另類想像',
		listTitle14: '從生理到心靈 「一個人」經濟大爆發',
		listTitle15: '租房得投履歷？秀自己免費住天龍國',
		listTitle16: '社會學老師狂想　一堂課改變台灣',
		listTitle17: '台北青銀共居的條件與機會：高齡社會與閒置公寓',
		listTitle18: '共生，更便宜',
		listTitle19: '趨勢「共生公寓」打破居住模式！',
		listTitle20: '加入吧，共享空間（三）：那些不只是用來工作的空間——The Common、來坐夥、玖樓',
		listSubtitle1: 'SOTOKOTO(ソトコト) 2017年12月号',
		listSubtitle2: '明報周刊',
		listSubtitle3: '關鍵評論網「2017年未來大人物」',
		listSubtitle4: '公視-獨立特派員',
		listSubtitle5: '小日子雜誌',
		listSubtitle6: 'Polysh',
		listSubtitle7: '社企流',
		listSubtitle8: 'TED x TKU',
		listSubtitle9: 'NPOst 公益交流站',
		listSubtitle10: '破點',
		listSubtitle11: '30雜誌',
		listSubtitle12: 'Green 綠建築雜誌',
		listSubtitle13: 'LaVie',
		listSubtitle14: '今周刊',
		listSubtitle15: '商業週刊',
		listSubtitle16: '天下雜誌',
		listSubtitle17: '台北村落之聲',
		listSubtitle18: '民視異言堂',
		listSubtitle19: 'TVBS',
		listSubtitle20: 'BIOS Monthly',
		interview: '採訪玖樓',
		download: '下載品牌書',
		require: '採訪需求',
		record: '採訪紀錄',
	},
	manager: {
		bannerTitle: '空間管理',
		summaryTitle: 'Hi we are 9floor',
		summary:
			'玖樓是一個以社群經營為導向的全方位共同生活空間品牌，具體工作項目從品牌諮詢、設計規劃、施工、招租與經營管理等，協助業主活化閒置資產，提升社區價值。',
		sectionTitle1: '發展共同生活空間，<br>是一個城市共生的多贏選擇',
		sectionDescription11:
			'從活化空間的角度來看，共同生活空間介於商旅與長租套房之間，講求經濟實惠的服務及可量化的物件產品。定價可較一般租賃房屋高，但建置與營運成本卻遠低於旅館，且不受景氣淡旺之影響，獲利相對穩定。透過專業團隊的經營與策劃、也利於更緊密及長期的顧客關係，物件再活化及保值。',
		sectionDescription12:
			'也透過社群營造創造出更多屬於在地的活力及故事，連帶提升在地社區的價值。為物業主、投資人、居住者與城市創造良性的共生、共創、共榮的關係。',
		sectionTitle2: '為什麼要與玖樓合作',
		sectionDescription21:
			'玖樓（9floor）為台灣共同生活空間的先驅及專業品牌。從零開始，我們逐步嘗試並期許能做出一個有理想性的共居生活品牌。短短三年內累積近三千人次申請入住，並擁有三萬多名網路社群粉絲。獲得媒體高度關注外，亦與公部門攜手，規劃三峽青銀共居宅與永和社會住宅。並於2017年成為 <a class="underline" href="https://news.ltn.com.tw/news/local/paper/1138446" target="_blank" rel="noopener noreferrer">台北市政府認證專業房東</a>',
		sectionDescription22:
			'放眼亞洲，我們與國內外相關創新組織緊密互動，更於2017年獲得香港 <a class="underline" href="https://www.socialinnovationaward.asia/about-us/" target="_blank" rel="noopener noreferrer">Asia Social Innovation Award</a> 、2016年首爾 <a class="underline" href="https://www.facebook.com/Anyse.Asia/" target="_blank" rel="noopener noreferrer">ANYSE</a> 台灣代表、及社企流iLab與台北市產發局育成計輔導。作為一個同時具備國際視野、在地經驗及新創管理能力，玖樓，將會是與您一起透過品牌加成，為資產創造更高價值的首選團隊。',
		sectionTitle3: '服務項目',
		row1Title: 'A.統籌規劃 ',
		row1Subtitle1: '1.共同生活空間',
		row1Subtitle2: '2.空間品牌企劃',
		row1Subtitle3: '3.社區社群體驗',
		row1Description1: '市場與場域分析評估、財務與效益分析評估、空間利用規劃、複合商業模式提案',
		row1Description2: '顧問諮詢、服務設計、經營準則制定、人力培訓、數位整合行銷',
		row1Description3: '社群活動企劃、線上社群活動企劃、街區共創企劃',
		row2Title: 'B.設計監造',
		row2Subtitle1: '1.風格裝修',
		row2Sbtitle2: '2.智能家居整合',
		row2Description1: '老屋整建、空間設計、景觀規劃',
		row2Description2: '智慧門禁、裝修工程',
		row3Title: 'C.經營管理',
		row3Subtitle1: '1.住客管理',
		row3Subtitle2: '2.物產管理',
		row3Description1: '會員審核招募、數位金流合約管理、顧客關係維繫',
		row3Description2: '清潔修繕、空間維護、物業保險',
		section3Title: '我們正在尋找以下合作夥伴，一起打造更多理想的共同生活空間',
		section3TitleWithHTML: '我們正在尋找以下合作夥伴， <br> 一起打造更多理想的共同生活空間',
		section3Sub1: '空置物業',
		section3Sub2: '驚喜企畫',
		section3Sub3: '異業結盟',
		section3Description1:
			'我們持續探索生活場域的更多可能，因此積極尋找策略夥伴，包含智慧家居、綠能家電、友善食材、設計、生活品味風格等生活產業，一同創造永續發展的城市。',
		section3Description2:
			'玖樓的共同生活空間，就像是散落在這座城市的有機培養皿，搜羅這座城市最酷的人事物。我們歡迎一切有趣的企畫提案，也積極尋找與社會設計、社區共生、未來創新相關的合作可能。',
		section3Description3:
			'我們不停在尋找新的物件空間，一個適合打造成兼顧居住者社交生活、與居住生活，擁有私人房間與共享空間的場域。必備條件為交通便捷，此外如果能沾染一些地方文化特色就更棒了！',
		blockquoteWithHTML: '想了解更多嗎？歡迎留下相關資料，我們會儘速安排專人與您聯繫',
		contactUs: '與我們聯繫',
		sloganLeft: '享受社交生活。',
		sloganRight: '在宜居的環境裡，',
		sloganTitle1: '什麼是共同生活空間<br />&nbsp;(co-living space)',
		sloganTitle2: '什麼是共同生活空間<br />&nbsp;(co-living space)',
		sloganContent:
			'其實生活除了工作睡覺外、也需要適當的社交、以及透過不同方式例如活動參與、自己下廚等等以提升自我。因應現代人的生活模式，近年來開始有人提倡與投入建立共同生活空間。比起傳統租房產業最大化私人空間/房間數來獲利，Co-Living強調適當比例的公共空間，例如公共廚房、共同工作空間、休憩空間、甚至健身房等等、以及平價但適切的空間設計。為的是讓每位居民能在宜居的環境裡同時享受社交生活。而管理單位亦能透過整合管理，大幅降低單一物件環境提升的成本，而得以有效率的創造出略高於市場定價，但遠高於水平的服務與空間。也因此共同生活空間有別於傳統的隔間套房，吸引到為數不少，對於生活品質有所追求的族群入住。',
	},
	coliving: {
		coliving: '共居生活',
		summaryTitle: 'Hi we are 9floor',
		summaryDescription:
			'玖樓是一個以社群經營為主的全方位共同生活空間品牌，透過空間與多元的社群關係，創造更豐富的生活體驗。',
		sloganTitle: '什麼是共同生活空間<br />&nbsp;(co-living space)',
		slogan: '房子是租來的，但生活不是',
		sloganLeft: '但生活不是。',
		sloganRight: '房子是租來的，',
		sloganContent:
			'所謂的生活除了回家睡覺外、也包含適當的社交、活動參與、放鬆休憩等等。而共同生活空間正是為了回應當代的城市人口組成，所提供的生活空間新選擇。比起出租套房雅房，共同生活空間更強調完善的服務與透過適當比例的公共空間來凝聚社群，例如公共廚房、共同工作空間、休憩空間等等。以適切簡約為設計原則，創造每位室 友能同時享受社交生活的宜居場域。',
		title1: 'A.共生空間',
		description1:
			'擁有居家輕鬆溫暖的氛圍，同時備有咖啡館的工作生活機能。不只是物件的冰冷堆疊，我們在最愛的角落放上一盞落地燈、植入綠意、及能與室友分享私房菜的大桌。簡約的設計風格，乘載平凡生活的更多樂趣。',
		imageDescription1: '家鄉拿手菜、或深夜的泡麵，共煮共食的過程總能交換到些溫馨八卦。',
		imageDescription2: '討論計畫、準備期中考、咖啡小聚，在這容納彼此的場域，一起創造回憶。',
		imageDescription3: '回家後在床躺下的瞬間，舒適簡約的小天地，是對一整天的努力最好的報償。',
		title2: 'B.便捷租約',
		description2:
			'訂閱式的線上繳租，讓租房跟聽Spotify一樣簡單。一張帳單、線上刷卡，一次解決所有費用。不管是實習外派，還是留學交換，最短一個月的彈性租期、便利人性的入住流程，再也不用被租約綁住精彩的人生規劃。',
		imageDescription4: '我們的費用包含能源、清潔服務、行政手續等，一張帳單解決所有費用。',
		imageDescription5: '信用卡自動扣款，再也不用每個月設提醒繳房租了。',
		imageDescription6: '外派、實習、短期計畫，一個月以上的短租都沒問題。',
		title3: 'C.日常支援',
		description3:
			'每週公共區域清潔與垃圾清運服務，家事分工免煩惱，生活品質不打折。線上客服即時通報，設備、生活問題不麻煩。',
		imageDescription7: '線上報修系統即時通報，24小時內回覆，專業修繕人員為居住品質把關。',
		imageDescription8:
			'定期的公共空間專業清潔、以及定量的垃圾與回收物清運服務。*垃圾清運服務有每週定量標準，超量或是未依規定處理者，仍須自行處理。',
		imageDescription9: '所有入住的房客皆投保富邦產險1500萬第三人意外責任險，在外生活更有保障。',
		title4: 'D.社群生活',
		description4:
			'自己的視野有限，多元的社群卻是無界無邊。無論你是誰、從哪裡來，我們都希望你能在玖樓找到有歸感的落腳處。不只是精彩的實體聚會活動，小聚、早午餐、泳池派對，開放自由的氛圍，跨界的文化交流，我們也有很棒的{{link}}。成為入住會員、找到與你興趣相符的夥伴，一起探索城市吧！',
		imageDescription10: '社交當然不只發生在自己家裏，線上社群認識城市裡其他有趣的村民。',
		imageDescription11: '圖書館、電影夜、泳池派對，社群公共空間讓最酷的大家一起共同創造。',
		imageDescription12: '創業夥伴、異國戀情，參加社群活動，讓緣份就此展開。',
		community: '線上社群',
	},
	sitemap: {
		sitemap: '網站地圖',
		member: '會員',
		checkin: '入住',
		ninthfloor: '玖樓',
		service: '服務',
		journal: '日誌',
		help: '協助',
		login: '登入',
		filter: '條件搜尋',
		area: '地域搜尋',
		pauian: '玖樓璞園',
		personalized: '為我推薦',
		about: '關於',
		media: '媒體',
		team: '團隊',
		contact: '聯繫',
		space: '空間管理',
		coliving: '共居生活',
		how: '如何申請',
		FAQ: '常見問題',
		contactUs: '聯繫我們',
		termsofService: '服務條款',
		privacy: '隱私權政策',
	},
	BookingInsto: {
		paymentDescription: '金流扣繳與退款說明',
		paymentItem1:
			'玖樓使用藍新金流NewebPay為支付系統， 支援 Visa, MasterCard, JCB 之信用卡、簽帳金融卡。',
		paymentItem2: '1.訂單設定完成後，將於每月自動扣款。如有需要，可隨時至會員頁查看扣款紀錄。',
		paymentItem3: '2.每月扣款日為租約起始日期。',
		paymentItem4: '3.除了首期款項以外，我們並不會預扣金額。',
		paymentItem5: '4.如有需要，未來仍可於會員頁變更扣款帳戶。',
		paymentItem6:
			'5.如使用非台幣銀行卡，相關匯率以及手續費將由入住會員自行吸收，實際詳情請自行與銀行確認。',
		agree: '我都知道了，快讓我付款吧！',
		cardDetail: '卡片資訊',
		cardNumber: '卡號',
		dateline: '到期日',
		zipCode: '安全碼',
		name: '姓名',
		continue: '前往付款',
		back: '上一步',
	},
	SocialSelectGroup: {
		otherSocialMedia: '新增其他社群連結',
		linkSocialMedia: '社群連結',
		choiceSocialMedia: '選擇社群',
		addLinkofSocialMedia: '新增此連結',
	},
	MemberBadge: {
		REGISTERED: '已註冊',
		MEMBERSHIP_UNDER_REVIEW: '資格審核中',
		MEMBERSHIP_DENIED: '資格未過',
		BASIC_MEMBER: '一般會員',
		CERTIFIED_MEMBER: '認證會員',
		RESIDENT_MEMBER: '入住會員',
		BLOCKED: '黑名單',
	},
	CoLivingSlider: {
		search: '搜尋物件',
		serviceDetail: '服務詳情',
	},
	CoLivingSection: {
		search: '搜尋物件',
		serviceDetail: '服務詳情',
		sectionTitle1: '品味風格',
		sectionDetail1:
			'擁有輕鬆溫暖的氛圍，同時備有咖啡館的工作生活機能。不只是物件的冰冷堆疊，我們在最愛的角落放上一盞落地燈、植入綠意、以及能與室友分享私房菜的大桌。簡約的設計風格，乘載平凡生活的更多樂趣。',
		sectionTitle2: '便捷彈性',
		sectionDetail2:
			'訂閱式的線上繳租，讓租房跟聽Spotify一樣簡單。一張帳單、線上刷卡，一次解決所有費用。不管是實習外派，還是留學交換，最短一個月的彈性租期、便利人性的入住流程，再也不用被合約綁住精彩的人生規畫。',
		sectionTitle3: '日常支援 ',
		sectionDetail3:
			'每週公共區域清潔與垃圾清運服務，家事分工免煩惱，生活品質不打折。雲端系統即時通報，不論設備、還是生活，都貼心的幫你搞定一切。',
		sectionTitle4: '社群生活',
		sectionDetail4:
			'一個人的視野有限，多元的社群卻是無界無邊。調酒師、小資族、自由工作者，無論你從哪裡來，都能在玖樓找到歸屬的落腳處。小聚、早午餐、泳池派對，開放自由的氛圍，跨界的文化交流，與室友一起認識城裡最棒的人事物。',
	},
	Home: {
		qouteblock: '加入我們，分享彼此的世界，如約翰藍儂曾《想像》的那樣。',
		moreButton: '更多物件',
	},
	LocationInfo: {
		roommate: '位室友',
	},
	RoomCard: {
		month: '月',
	},
	breadcrumb: {
		moveIn: '入住',
		roomSearch: '房源搜尋',
		geographicSearch: '地圖搜尋',
		home: '玖樓',
		about: '關於',
		media: '媒體',
		team: '團體',
		contact: '聯繫',
		service: '服務',
		spaceManagement: '空間管理',
		coliving: '共居生活',
		member: 'Member',
		overview: '總覽',
		add: '新增個人資料',
		settings: '設定個人資料',
		favorites: '收藏',
		propertyViewingHistory: '預約紀錄',
		reservationHistory: '入住紀錄',
		onlineCommunity: '社群',
		termsOfService: '服務條款',
		description: '服務說明',
		privacyPolicy: '隱私權政策',
		sitemap: '網站地圖',
		room: '房源',
		booking: '預訂入住',
		user: 'User',
		reservation: '預約紀錄',
		renewYourLease: '預訂續住',
		book: '入住紀錄',
		appointment: '預約看房',
		checkin: '預約入住時間',
		checkout: '預約退房時間',
		cancel: '取消預約',
		changeAppointment: '變更預約',
		interview: '預約訪談',
	},
	cookie: {
		title: 'Cookie 提醒',
		description:
			'此網站使用Cookie。繼續使用此網站即表示您同意使用 Cookie。若要瞭解更多資訊，包括如何控制 Cookie，請參閱我們的',
		policy: 'Cookie 政策',
		buttonText: '同意',
	},
	community: {
		qouteblock: '加入我們，分享彼此的世界，如約翰藍儂曾《想像》的那樣。',
		moreButton: '更多物件',
		communitySearch:
			'自己的視野有限，多元的社群卻是無界無邊。無論你是誰、從哪裡來，我們都希望玖樓是你能感受到歸屬感的落腳處。快來體驗我們最新推出，目前為入住室友限定的線上社群功能吧！只要前往會員設定頁進行社群資料公開、完成興趣標籤、instagram串連、最愛的歌曲等設定，就可以開始搜尋與你趣味相同的新朋友！',
		selectCity: '選擇城市',
		placeholder: '輸入關鍵字，ex:籃球, 設計',
		findbutton: '找同好',
		communityAlert: '嗨，目前本服務僅入住會員限定。',
	},
	previewSection: {
		review: '審核中',
		reviewDetail: '收到申請了噢，審核時間約為2-3個工作天（未含六日、國定假日)，感謝你的耐心等候!',
	},
	reservationCancel: {
		confirm: '確認取消',
		reason: '取消原因',
		AboutToCancel: '您即將取消',
		cancelAlert: '真的要取消嗎！取消後，已使用的看房次數也無法恢復噢，當月還剩 {{number}} 次。',
		cancellation: '確認取消',
	},
	songList: {
		song: '請輸入歌曲名稱',
		addSong: '新增',
	},
	roommateDetail: {
		favoriteSong: '最愛歌曲',
		communityLink: '社群連結',
		more: '載入更多',
	},
};



// WEBPACK FOOTER //
// ./src/util/resources/zh-TW.js